import '../../../../scss/PowerTabs.scss';

export const CustomP = ({data}) => {
    const className = data.displayName ? "" : "missingText"
    return <p className={className}>{data.displayName ?? data.id}</p>
}